import * as colors from '@mui/material/colors';

export const lightPalette = {
  background: {
    default: 'hsl(220, 20%, 97%)',
    paper: 'hsl(0, 0%, 100%)',
  },
  font: {
    primary: 'hsl(220, 20%, 10%)',
    secondary: 'hsl(220, 10%, 45%)',
    disabled: 'hsl(220, 10%, 45%)',
    hint: 'hsl(215, 9%, 62%)',
  },
  text: {
    primary: 'hsl(220, 20%, 10%)',
    secondary: 'hsl(220, 10%, 45%)',
    disabled: 'hsl(220, 10%, 45%)',
  },
  action: {
    disabled: 'hsl(220, 10%, 55%)',
    disabledBackground: 'hsl(220, 15%, 90%)',
  },
  primary: {
    main: 'hsl(24, 100%, 50%)',
    dark: 'hsl(18, 100%, 50%)',
    light: 'hsl(24, 100%, 55%)',
    contrastText: 'hsl(0, 0%, 100%)',
  },
  secondary: {
    main: 'hsl(220, 15%, 92%)',
    dark: 'hsl(220, 15%, 94%)',
    light: 'hsl(220, 15%, 98%)',
    contrastText: 'hsl(220, 20%, 30%)',
  },
  error: {
    main: 'hsl(0, 75%, 50%)',
    dark: '#b21a1a',
    light: '#e54d4d',
    contrastText: '#ffffff',
  },
  input: {
    main: 'hsl(0, 0%, 100%)',
    dark: 'hsl(220, 15%, 90%)',
    contrastText: 'hsl(220, 20%, 10%)',
    placeholderText: 'hsl(215, 9%, 62%)',
    disabled: 'hsl(220, 15%, 94%)',
  },
  border: {
    main: 'hsl(220, 15%, 88%)',
  },
  header: {
    main: 'hsl(0, 0%, 100%)',
    contrastText: 'hsl(220, 20%, 10%)',
  },
  containerHeader: {
    main: 'hsl(0, 0%, 100%)',
    contrastText: 'hsl(220, 20%, 10%)',
  },
  menu: {
    primary: 'hsl(0, 0%, 100%)',
    primaryDark: 'hsl(220, 15%, 94%)',
    secondary: 'rgba(255, 102, 0, 0.1)',
    secondaryDark: 'rgba(255, 102, 0, 0.3)',
    contrastText: 'hsl(220, 10%, 45%)',
    contrastTextDark: 'hsl(220, 20%, 10%)',
    divider: 'hsl(220, 15%, 88%)',
    secondaryContrastText: 'hsl(24, 100%, 50%)',
  },
  tabControl: {
    backgroundColor: 'hsl(220, 15%, 92%)',
    primary: 'hsl(0, 0%, 100%)',
    primaryDark: 'hsl(220, 15%, 94%)',
    secondary: 'hsl(24, 100%, 50%)',
    secondaryDark: 'hsl(24, 100%, 55%)',
    contrastText: 'hsl(220, 10%, 45%)',
    contrastTextDark: 'hsl(220, 20%, 10%)',
    secondaryContrastText: 'hsl(0, 0%, 100%)',
  },
  contentBackground: {
    grey: 'hsl(220, 15%, 98%)',
  },
  paper: {
    backgroundColor: 'hsl(0, 0%, 100%)',
    hoverBackgroundColor: 'hsl(0, 0%, 100%)',
    borderColor: 'hsl(220, 15%, 88%)',
    hoverBorderColor: 'hsl(24, 100%, 50%)',
  },
  warning: {
    main: 'hsl(45, 100%, 45%)',
  },
  info: {
    main: '#fcb23b',
  },
  success: {
    main: 'hsl(142, 70%, 40%)',
    dark: '#167a58',
    light: '#49ad8b',
    contrastText: '#ffffff',
  },
  custom: {
    red: 'hsl(0, 75%, 50%)',
    white: '#ffffff',
    green: '#8abb2a',
    black: '#000000',
    linkColor: 'hsl(24, 100%, 50%)',
  },
  shadow: 'rgba(41, 48, 61, 0.22)',
  footer: {
    color: 'hsl(220, 10%, 45%)',
    activeColor: 'hsl(24, 100%, 50%)',
    backgroundActiveColor: 'rgba(255, 102, 0, 0.3)',
  },
  exerciseStatus: {
    started: 'rgba(17, 75, 194, 0.3)',
    notStartedOddLine: 'transparent',
    notStartedEvenLine: 'transparent',
    doLateOddLine:
      'linear-gradient(90deg, rgba(252, 178, 59, 0.3), transparent)',
    doLateEvenLine:
      'linear-gradient(90deg, rgba(252, 178, 59, 0.3), transparent)',
    skippedOddLine:
      'linear-gradient(90deg, rgba(204, 49, 10, 0.3), transparent)',
    skippedEvenLine:
      'linear-gradient(90deg, rgba(204, 49, 10, 0.3), transparent)',
    finishedOddLine:
      'linear-gradient(90deg, hsla(142 70% 45% / .15), transparent)',
    finishedEvenLine:
      'linear-gradient(90deg, hsla(142 70% 45% / .15), transparent)',
  },
  primaryTransparent: 'rgba(255, 102, 0, 0.15)',
  primaryGradient:
    'linear-gradient(135deg, rgb(255, 102, 0), rgb(255, 159, 26))',
  successGradient:
    'linear-gradient(135deg, rgb(31, 173, 83), rgb(27, 152, 110))',
  disabled: 'hsl(220, 15%, 94%)',
  primarySamitransparent: 'hsl(24, 100%, 90%)',
  successSamitransparent: 'hsl(142, 70%, 90%)',
  warningSamitransparent: 'hsl(45, 100%, 90%)',
  errorSamitransparent: 'hsl(0, 75%, 90%)',
  ...colors,
} as const;
